import React, { useContext } from "react";
import PropTypes from "prop-types";
import { useQuery } from "react-apollo";
import { Field, Control, Label, Select, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { ALL_CUSTOMERS_QUERY } from "../../graphql/Customers/Customers.graphql";
import { ModalContext } from "../ModalProvider";
import { useCurrentUserRoles } from "../Authorization";

function CustomerSelect({
  variables,
  value,
  label,
  size,
  name,
  icon,
  onChange,
  required,
  readOnly,
  addon,
  addons,
  showHelp = false,
  showCityAndState = true,
  showLabel
}) {
  const { setModalOpen } = useContext(ModalContext);
  const roles = useCurrentUserRoles();
  const { data, loading, error } = useQuery(ALL_CUSTOMERS_QUERY, { variables });
  const selectedCustomer = data?.Customers?.find(
    c => c.RecId === parseInt(value)
  );
  const isAdmin = roles.some(role => role === "ADMIN");
  const isBill = roles.some(role => role === "FIN");
  // Liz has asked to remove this logic.
  // const isNoBill = selectedCustomer?.CustomerNo === "NOBILL";

  return (
    <Field>
      {showLabel && (
        <React.Fragment>
          {showHelp && (isAdmin || isBill) ? (
            <Label
              as={Link}
              size={size}
              tabIndex="-1"
              textColor="link"
              to={
                selectedCustomer
                  ? `/finance/customers/${selectedCustomer?.RecId}/details`
                  : "/finance/customers"
              }
              onClick={() => setModalOpen(false)}
            >
              {label}
            </Label>
          ) : (
            <Label size={size}>{label}</Label>
          )}
        </React.Fragment>
      )}
      <Field kind={addons.length ? "addons" : ""}>
        <Control iconLeft expanded={!!addons.length} size={size}>
          <Select.Container
            fullwidth
            color={error ? "danger" : ""}
            size={size}
            state={loading || !data ? "loading" : undefined}
          >
            <Select
              disabled={readOnly}
              name={name}
              required={required}
              value={value}
              onChange={onChange}
            >
              <Select.Option value="">{label}</Select.Option>
              {!loading &&
                data.Customers.map((Customer, i) => (
                  <Select.Option
                    key={`employee-select-${i}`}
                    value={Customer.RecId}
                  >
                    {`${Customer.CustomerNo}${
                      Customer.Name ? ` - ${Customer.Name}` : ""
                    }${
                      showCityAndState && Customer.City && Customer.State
                        ? ` - ${Customer.City}, ${Customer.State}`
                        : ""
                    }`}
                  </Select.Option>
                ))}
            </Select>
          </Select.Container>
          {icon && (
            <Icon align="left" size={size}>
              <FontAwesomeIcon icon={icon} />
            </Icon>
          )}
        </Control>
        {!!addon && <Control>{addon}</Control>}
        {!!addons.length && addons.map(item => <Control>{item}</Control>)}
      </Field>
    </Field>
  );
}
CustomerSelect.propTypes = {
  value: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.string,
  variables: PropTypes.object,
  icon: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  readOnly: PropTypes.bool,
  addon: PropTypes.node,
  addons: PropTypes.array,
  showHelp: PropTypes.bool,
  showCityAndState: PropTypes.bool,
  showLabel: PropTypes.bool
};

CustomerSelect.defaultProps = {
  variables: {
    where: { Active: true },
    orderByMulti: ["CustomerNo_ASC"]
  },
  addons: [],
  showLabel: true
};
export default CustomerSelect;
